import React from "react";
import GroupAccountDashboard from "../Components/GroupAccountDashboard";
import Navbar from "../Components/Navbar";
import '../Styles/GroupAccount.scss';
import {Helmet} from "react-helmet";

function GroupAccount() {
 

   return (
      <div>
         <Helmet>
            <title>Group Account Dashboard - Camp Connect</title>
         </Helmet>
         <div className="groupAccountNavbar">
            <Navbar/>
         </div>
         <GroupAccountDashboard/>
      </div>
   )
};
export default GroupAccount;
